"use client";

import {
  TypeComparisonModule,
  TypeMultipleComparisonModule,
} from "@contentful/types";
import { useState } from "react";

import { ComparisonModule } from "./ComparisonModule";
import { SelectorPills } from "./SelectorPills";

export function MultiComparisonModule({
  multiComparisonModule,
}: {
  multiComparisonModule: TypeMultipleComparisonModule<"WITHOUT_UNRESOLVABLE_LINKS">;
}) {
  const {
    comparisonA,
    comparisonB,
    comparisonC,
    comparisonD,
    packageComparisons,
  } = multiComparisonModule.fields;

  const [selectedComparison, setSelectedComparison] = useState(0);

  const handleComparisonClick = (index: number) => {
    setSelectedComparison(index);
  };

  // Indices address the four Contentful slots, which can have gaps, so the
  // pill row is built from the filled ones and mapped back through `index`.
  const comparisonTabs = [comparisonA, comparisonB, comparisonC, comparisonD]
    .map((label, index) => ({ id: String(index), label, index }))
    .filter((tab): tab is { id: string; label: string; index: number } =>
      Boolean(tab.label),
    );

  // The "talk to us" card is no longer drawn here: pages use the Contentful
  // "Consult Call Module" (Design Gallery) instead. This module only switches
  // between its comparison tables.
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 py-8">
      <div className="w-full max-w-6xl px-6 pb-8">
        <div>
          {packageComparisons && packageComparisons[selectedComparison] && (
            <div>
              <ComparisonModule
                key={packageComparisons[selectedComparison]?.sys.id}
                comparisonModule={
                  packageComparisons[
                    selectedComparison
                  ] as TypeComparisonModule<"WITHOUT_UNRESOLVABLE_LINKS">
                }
                isMultiComparisonModule={true}
                tabSwitcher={
                  <div className="flex w-full flex-row items-center justify-center p-4">
                    <SelectorPills
                      label="Comparison"
                      options={comparisonTabs}
                      selectedIndex={comparisonTabs.findIndex(
                        (tab) => tab.index === selectedComparison,
                      )}
                      onSelect={(i) =>
                        handleComparisonClick(comparisonTabs[i].index)
                      }
                    />
                  </div>
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
